<script lang="ts">
  import {onMount} from "svelte";
  import { format, parseISO } from "date-fns";
  import {userService} from "$lib/services/user.service";
  import type {IRollover} from "$lib/interfaces/IRollover";
  import {openDialog} from "$lib/stores/dialogStores";
  import RolloverStatus from "$lib/components/RolloverStatus.svelte";
  import {translate} from "$lib/i18n";

  let typeFilter = 'all';
  let rollovers: IRollover[] = []
  let data = {
    page: 0,
    size: 20
  }

  onMount(
      async () => {
        getWagers();
      }
  )

  function getWagers() {
    userService.getUserWagers(data).then((response: any) => {
      if (response) {
        rollovers = response.data.data;
      }
    }).catch(err => {
      console.error(err);
    });
  }

  function openDetails(wager: IRollover) {
    openDialog('RolloverDetailsModal', wager);
  }
</script>

<div class="bg-primary-blue md:p-4 pl-2 rounded-2xl">
  <div class="mt-4 md:mt-6">
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left rtl:text-right ">
        <thead class="text-white text-left bg-primary-dark text-nowrap ">
        <tr>
          <th class="py-3 md:px-6 px-4">{$translate('Type')}</th>
          <th class="py-3 md:px-6 px-4">{$translate('Time')}</th>
          <th class="py-3 md:px-6 px-4">{$translate('Amount')}</th>
          <th class="py-3 md:px-6 px-4">{$translate('Status')}</th>
        </tr>
        </thead>
        <tbody class="text-gray-300 ">
        {#each rollovers as wager}
          <tr class="even:bg-primary-dark  hover:bg-primary-lightBlue/40 cursor-pointer"
              on:click={() => openDetails(wager)}>
            <td class="px-4 md:px-6 py-4 font-medium whitespace-nowrap">{wager.type}</td>
            <td class="px-4 md:px-6 py-4 font-medium whitespace-nowrap">{format(parseISO(wager.createdAt), 'MMM d, yyyy')}</td>
            <td class="px-4 md:px-6 py-4 font-medium whitespace-nowrap text-green-600">
              +{wager.transaction.amount} {wager.transaction.cryptoCurrency.shortName}</td>
            <td class="px-4 md:px-6 py-4 font-medium whitespace-nowrap">
              <RolloverStatus status={wager.status}/>
            </td>
          </tr>
        {/each}
        </tbody>
      </table>
    </div>
  </div>
</div>
